import { combineReducers } from 'redux';

import leaderboards     from './leaderboards.js'
import loading          from './loading.js'  


/*
    NB: Reducers must be pure functions (no side effects)
*/

const combinedReducer = combineReducers({
    leaderboards,
    
    loading
    
});

const mainReducer = (state, action) => {
    if (action.type === 'USER_SIGNOUT' || action.type==='CLEAR_STORE') {
        state = undefined;
    }
    return combinedReducer(state, action);
}

export default mainReducer;


//Composite selectors
export const getCategoriesByObjectiveId = (state, objectiveId) => {
    return getObjectiveCategoriesByObjectiveId(state.objectiveCategories, objectiveId).map(oc => getCategory(state.categories, oc.categoryId));
};
